Directives.ChatDirective = function ChatDirective() {

    // @ngInject
    function ChatDirectiveControllerFunc($scope, $injector, UsersManager, ConversationsManager, WebsocketHelperService,
                                         $timeout, PopupMessageService, ConversationService, AnalyticsService, AppConfigService,
                                         moment) {


        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ChatDirectiveController';

        var self = this;
        this.destroyed = false;
        this.ConversationService = ConversationService;
        this.ConversationsManager = ConversationsManager;
        this.WebsocketHelperService = WebsocketHelperService;
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.$timeout = $timeout;
        this.moment = moment;
        this.UsersManager = UsersManager;
        this.isMalkut = AppConfigService.isMalkutServer();
        this.isProduction = ConversationService.isProduction;
        this.loaded = false;

        this.initialize();
    }

    var ChatDirectiveController = Class(Controllers.BaseController, {
        constructor: ChatDirectiveControllerFunc,

        initialize: function initialize() {


            this.userIds = {};
            this.messagesPerPage = this.ConversationsManager.getDefaultMessagesPerPage();
            this.membersCount = 23;


            this.updateCurrentUser();
            this.conversation = {_id: this.conversationId};
            this.displayTitle = "";
            this.otherUser = {};
            this.messages = [];
            this.user = this.UsersManager.getCurrUser();

            this.isLiveChat = this.chatType === 'liveChat';

            if (this.isLiveChat) {
                this.wsCallback = this.liveChatNewMessageReceived.bind(this);
            } else {
                this.wsCallback = this.loadNewMessages.bind(this);
            }

            if (this.isLiveChat) {

                this.WebsocketHelperService.once('websocket_connected', function connected() {

                    var allowChat = true;
                    if (!this.user) {
                        allowChat = false;
                    }

                    if (this.user.isClient() || this.isMalkut) {
                        allowChat = false;
                    }

                    if (allowChat) {
                        this.loadConversationFromService(this.conversation._id);
                    }
                }.bind(this));


            }

            this.UsersManager.on('currentUserChanged', this.updateCurrentUser.bind(this));
            this.UsersManager.on('loggingOut', this.cleanUp.bind(this));
            this.UsersManager.on('loggingIn', this.initialize.bind(this));
            if (!this.isLiveChat) {
                this.ConversationService.on('updateDirectMessagingConversationId', this.updateDirectMessagingConversationId.bind(this));
            } else {
                this.ConversationService.on('updateCommunityFeedConversationId', this.updateCommunityFeedConversationId.bind(this));
            }

            this.ConversationService.on('closeConversation', this.closeChat.bind(this));
            this.ConversationService.on('chatOpened', this.onChatOpened.bind(this));

            this.$scope.$on('$destroy', function () {
                if (!this.isLiveChat) {
                    this.ConversationService.off('updateDirectMessagingConversationId');
                }
            }.bind(this));


        },

        loadConversationFromService: function loadConversationFromService(conversation_id) {

            if (!this.conversationLoaded) {

                this.conversationLoaded = true;

                // we were registered on another conversation do unregister
                if (this.conversation._id) {
                    this.WebsocketHelperService.unregisterFromRoom(this.conversation._id);
                }

                this.conversation = {};
                this.conversation._id = conversation_id;
                this.messages.splice(0, this.messages.length);
                this.itemIds = [];
                this.oldestMessageFetched = false;

                this.WebsocketHelperService.registerToRoom(this.conversation._id, this.wsCallback);

                this.$scope.$on('$destroy', function () {
                    this.WebsocketHelperService.unregisterFromRoom(this.conversation._id);
                }.bind(this));


                var promise = this.ConversationsManager.getConversation(this.conversation);

                if (promise) {
                    promise.then(function sucess(res) {
                        angular.copy(res.data, this.conversation);
                        this.conversation.feed.feed_users = this.conversation.feed.feed_users || {};

                        if (res.data.feed.feed_items.length < this.messagesPerPage) {
                            this.oldestMessageFetched = true;
                        }
                        this.initMessagesFromFeed(res);
                        // this.user.getRecentConversationNotifications();
                        // this.displayTitle = this.getConversationTitle(this.conversation);
                        this.otherUser = this.getOtherUser(this.conversation);

                        if (this.updateConversationLoaded) {
                            this.updateConversationLoaded();
                        }
                    }.bind(this));
                }

            } else {
                this.loadNewMessages();
            }
        },


        sendMessage: function sendMessage(message) {


            if (this.isLiveChat && this.user.isDemo() && this.isProduction) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info,
                    'Demo users cannot send messages in production!!');

                return;
            }
            this.conversation.feed.feed_items.push(message);
            this.ConversationsManager.sendConversationMessage(this.conversation, message.text)
                .then(
                    function sucsess(res) {
                        this.itemIds.push(res.data._id);
                        message._id = res.data._id;
                        message.sent = true;

                        var analyticsArgs = {
                            conversation_id: this.conversation._id,
                            conversation_type: this.chatType
                        };

                        this.AnalyticsService.track(self,
                            this.AnalyticsService.analytics_events.send_conversation_message,
                            analyticsArgs);
                    }.bind(this))

                .catch(function fail(resp) {
                    message.error = true;
                    // stop the loader
                    message.sent = true;
                    // console.log("error" + resp);
                }.bind(this));
        },

        updateOnlineOnLocalCopy: function updateOnlineOnLocalCopy(data) {
            if (this.otherUser && data.action && data.hb_user) {

                if (this.otherUser._id === data.hb_user) {

                    if (data.action === "join") {
                        this.otherUser.web_socket_connection_status = "connected";
                    } else if (data.action === "leave") {
                        this.otherUser.web_socket_connection_status = null;

                    }
                }
            }
        },


        loadNewMessages: function loadNewMessages(data) {

            if (data) {
                this.updateOnlineOnLocalCopy(data);
            }


            var promise = this.ConversationsManager.getConversation(this.conversation, this.conversation.last_item_ts)

            if (promise) {
                promise.then(function sucess(res) {
                    this.addMessagesToFeed(res.data, true);
                }.bind(this));
            }
        },

        loadOlderMessages: function loadOlderMessages() {

            if (this.oldestMessageFetched) {
                return;
            }

            var promise = this.ConversationsManager.getConversation(this.conversation, null, this.conversation.earliest_item_ts)
            if (promise) {
                promise.then(function sucess(res) {
                    if (res.data.feed.feed_items.length < this.messagesPerPage) {
                        this.oldestMessageFetched = true;
                    }
                    this.addMessagesToFeed(res.data, false);
                }.bind(this));
            }

        },

        initMessagesFromFeed: function initMessagesFromFeed(res) {
            this.conversation.feed.feed_items = [];
            this.addMessagesToFeed(res.data, false);
        },

        addMessagesToFeed: function addMessagesToFeed(data, newerMessages) {

            if (data.feed) {

                if (data.feed.feed_items && data.feed.feed_items.length > 0) {

                    var latestFromData = data.feed.feed_items[data.feed.feed_items.length - 1].created_at;

                    if (!this.conversation.last_item_ts || this.moment(latestFromData).isAfter(this.conversation.last_item_ts)) {
                        this.conversation.last_item_ts = latestFromData;
                    }

                    var earliestFromData = data.feed.feed_items[0].created_at;

                    if (!this.conversation.earliest_item_ts || this.moment(earliestFromData).isBefore(this.conversation.earliest_item_ts)) {
                        this.conversation.earliest_item_ts = earliestFromData;
                    }
                }

                if (data.feed.feed_users) {
                    this.mergeFeedUsers(data.feed.feed_users);
                }

            }

            var feed_items = data.feed.feed_items || [];
            var feed_users = this.conversation.feed.feed_users || [];

            var itemsToAdd = [];
            _.each(feed_items, function eachMessage(feedItem) {
                if (this.itemIds.indexOf(feedItem._id) == -1) {
                    this.itemIds.push(feedItem._id);

                    feedItem.text = feedItem.data.html_body;
                    feedItem.user = feed_users[feedItem.sender_id];
                    feedItem.sent = true;
                    feedItem.date = Date.parse(feedItem.data.sent_on);
                    itemsToAdd.push(feedItem);

                }
            }.bind(this));

            if (newerMessages && itemsToAdd.length > 0) {

                this.ConversationService.newMessageAddedToConversation(this.conversation._id);
                this.conversation.feed.feed_items = this.conversation.feed.feed_items.concat(itemsToAdd);

            } else if (itemsToAdd.length > 0) {

                this.conversation.feed.feed_items = itemsToAdd.concat(this.conversation.feed.feed_items);
            }
        },

        liveChatNewMessageReceived: function liveChatNewMessageReceived() {
            if (this.visible) {
                this.loadNewMessages();
            } else {
                this.newUnreadMessages();
            }
        },

        mergeFeedUsers: function mergeFeedUsers(newUsers) {

            for (var key in newUsers) {
                this.conversation.feed.feed_users[key] = newUsers[key];
            }
        },

        closeChat: function closeChat() {

            if (this.conversation._id) {
                if (!this.isLiveChat) {
                    this.WebsocketHelperService.unregisterFromRoom(this.conversation._id);
                    this.conversation = {};
                    this.messages = [];
                    this.itemIds = [];
                }
            }
        },

        cleanUp: function cleanUp() {
            this.closeChat();
            // we were registered on another conversation do unregister
            if (this.conversation._id) {
                this.WebsocketHelperService.unregisterFromRoom(this.conversation._id);
                this.conversation = {};
                this.conversationLoaded = false;
            }


        },

        getOtherUser: function getOtherUser(conversation) {
            var otherUsers = _.filter(conversation.feed.feed_users, function userFilter(user, key) {
                return key != this.user._id;
            }.bind(this));

            return otherUsers[0];
        },

        updateCurrentUser: function updateCurrentUser() {

            this.user = this.UsersManager.getCurrUser();
            this.enableLiveChatForCurrentUser = false;

            //we only show live feed to vendors who already sent a file (not fresh trialers)
            if (this.user && this.user.isVendor() && (this.user.last_file_sent_time || this.user.isHBInvoicing())) {
                this.enableLiveChatForCurrentUser = true;
            }
        },

        updateDirectMessagingConversationId: function updateDirectMessagingConversationId(conversationId) {

            if (!this.isLiveChat) {
                if (this.conversation._id != conversationId) {
                    this.conversationLoaded = false;
                }

                this.loadConversationFromService(conversationId);
            }

        },

        updateCommunityFeedConversationId: function updateDirectMessagingConversationId(conversationId) {

            if (this.isLiveChat) {
                if (this.conversation._id != conversationId) {
                    this.conversationLoaded = false;
                }

                this.loadConversationFromService(conversationId);
            }
        },

        chatOpened: function chatOpened() {
            this.$timeout(function timedOut() {
                this.ConversationService.chatOpened(this.conversation._id);
            }.bind(this), 0);

        },

        onChatOpened: function onChatOpened(conversationId) {
            if (conversationId !== this.conversation._id) {
                this.closeChat();
            } else {
                this.loadNewMessages();
            }
        }

    });

    return {
        controller: ChatDirectiveController,
        bindToController: true,
        controllerAs: 'chatVm',
        restrict: 'AE',
        scope: {
            chatType: '@',
            conversationId: '=',
            newUnreadMessages: '&',
            updateConversationLoaded: '&',
            membersCountUpdated: '&?',
            visible: '=',
            otherUser: '=?'

        },
        templateUrl: 'angular/app/modules/core/features/chat/chat_directive_template.html'
    };
};
